import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectOptions } from '@cbuild/controls';
import { take } from 'rxjs';
import { TransferCustomerService } from './transfer-customer.service';

@Component({
  selector: 'cs-transfer-customer',
  standalone: false,
  templateUrl: './transfer-customer.component.html',
  styleUrls: ['./transfer-customer.component.scss']
})
export class TransferCustomerComponent implements OnInit {
  @Input() public infoForm: FormGroup;
  @Input() public customersCount: number;
  @Input() public uid: string;
  @Input() public clickedSubmit: boolean;
  public asyncLoading: boolean;
  public userOptions: SelectOptions;

  constructor(
    private fb: FormBuilder,
    private service: TransferCustomerService
  ) {}

  public ngOnInit(): void {
    this.infoForm.addControl(
      'customerFormGroup',
      this.fb.group({
        assignedUser: ['']
      })
    );
    this.getUsers();
  }

  public getUsers(): void {
    this.asyncLoading = true;
    this.service
      .getCrmUsers()
      .pipe(take(1))
      .subscribe(_ => {
        this.asyncLoading = false;
        this.userOptions = _.filter(users => users.value !== this.uid);
      });
  }

  get formData(): FormGroup {
    return this.infoForm.get('customerFormGroup') as FormGroup;
  }
}
